import React, { useMemo, useState } from "react";
import ShopProductGrid from "../components/product/ShopProductGrid";
import ProductFilters from "../components/product/ProductFilters";
import Seo from "../components/seo/Seo";
import {
  catalogProducts,
  filterProducts,
} from "../utils/productFilters";

const toggleSelection = (current, value) =>
  current.includes(value)
    ? current.filter((item) => item !== value)
    : [...current, value];

const ShopPage = () => {
  const [productTypes, setProductTypes] = useState([]);
  const [areas, setAreas] = useState([]);

  const filteredProducts = useMemo(
    () =>
      filterProducts(catalogProducts, {
        productTypes,
        areas,
      }),
    [productTypes, areas],
  );

  const clearAllFilters = () => {
    setProductTypes([]);
    setAreas([]);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-gray-900 to-black py-3 sm:py-4">
      <Seo
        title="Shop All Products"
        description="Browse the full JmoLux catalog. Filter by product type and area — soaps, creams, scrubs, lash supplies, medical essentials and more."
        path="/shop"
      />

      <div className="container mx-auto px-4 sm:px-6">
        <div className="mb-2 text-center">
          <h1 className="text-xs font-light uppercase tracking-[0.2em] text-white sm:text-sm">
            Full catalog
          </h1>
        </div>

        <ProductFilters
          productTypes={productTypes}
          areas={areas}
          onToggleProductType={(id) =>
            setProductTypes((current) => toggleSelection(current, id))
          }
          onToggleArea={(id) =>
            setAreas((current) => toggleSelection(current, id))
          }
          onClearAll={clearAllFilters}
          productList={catalogProducts}
          resultCount={filteredProducts.length}
          totalCount={catalogProducts.length}
        />

        {filteredProducts.length === 0 ? (
          <div className="rounded-2xl border border-white/10 bg-white/5 px-6 py-16 text-center">
            <p className="text-lg text-white">No products match your filters</p>
            <p className="mt-2 text-sm text-gray-400">
              Try removing a filter or clearing all selections.
            </p>
            <button
              type="button"
              onClick={clearAllFilters}
              className="mt-6 rounded-full border border-amber-400/40 px-5 py-2 text-sm text-amber-300 transition-colors hover:border-amber-400 hover:text-amber-200"
            >
              Clear filters
            </button>
          </div>
        ) : (
          <ShopProductGrid products={filteredProducts} />
        )}
      </div>
    </div>
  );
};

export default ShopPage;
